import {l} from "../../src/ts/debug/debug";

export class Header {

    private readonly SELECTOR_NAV: string = '.header__navigation';
    private readonly SELECTOR_NAV_TOGGLE: string = '.header__togglebutton';
    private readonly SELECTOR_NAV_WRAPPER: string = '.full-nav__navigation';

    private readonly SELECTOR_MOBILE_SECOND_LEVEL_LINK: string = '.full-nav__navigation-item-link.has-children';
    private readonly SELECTOR_MOBILE_SECOND_LEVEL_CONTAINER: string = '.full-nav__navigation-wrapper--second-level';
    private readonly SELECTOR_MOBILE_MAIN_LEVEL_CONTAINER: string = '.full-nav__navigation-wrapper--main-level';

    //private readonly SELECTOR_SEARCH_TOGGLE: string = '.header__search-button';
    //private readonly SELECTOR_SEARCH_CONTAINER: string = '.header__search-wrapper-desktop';
    //private readonly SELECTOR_SEARCH_INPUT: string = '.header__search-input-desktop';
    //private readonly STATE_SEARCH_OPEN: string = 'search-open';


    private readonly SCROLL_AMOUNT_MIN: number = 50; //when STATE_NAV_HIDDEN is applied
    private readonly SCROLL_AMOUNT_MAX: number = 300; //when STATE_SCROLLED is applied

    private readonly STATE_NAV_HIDDEN: string = 'hidden';
    private readonly STATE_SCROLLED: string = 'header--scrolled';


    private readonly STATE_ARIA_NAV_OPEN: string = 'true';
    private readonly STATE_ARIA_NAV_CLOSED: string = 'false';

    private readonly STATE_MOBILE_NAV_SECOND_LEVEL: string = 'second-level-open';

    private readonly NAV_BUTTON_ACTIVE_CLASS: string = 'is-active';
    private readonly NAV_BUTTON_SECOND_LEVEL_CLASS: string = 'is-second-level';
    private readonly NAV_BUTTON_STYLE_HAMBURGER: string = 'hamburger--squeeze';
    private readonly NAV_BUTTON_STYLE_ARROW: string = 'hamburger--arrow';

    private readonly NAV_OPEN_BODY_CLASS: string = 'nav_open';


    private readonly MIN_DESKTOP_NAV_WIDTH: number = 1024;

    private $header: JQuery;
    private $navigation: JQuery;
    private $navWrapper: JQuery;
    private $mainLevelContainer: JQuery;
    private $secondLevelContainer: JQuery;
    private $navButton: JQuery;

    //private $searchToggle: JQuery;
    //private $searchInput: JQuery;
    //private $searchContainer: JQuery;
    //private mouseDown: boolean = false;


    private isNavOpen: boolean = false;
    private isSecondLevelOpen: boolean = false;

    private $backgroundElements: JQuery;

    private lastScrollPosition: number;


    constructor() {
        this.$header = $('header.header');
        this.$navButton = this.$header.find(this.SELECTOR_NAV_TOGGLE);
        this.$navigation = this.$header.find(this.SELECTOR_NAV);
        this.$navWrapper = this.$header.find(this.SELECTOR_NAV_WRAPPER);
        this.$mainLevelContainer = this.$header.find(this.SELECTOR_MOBILE_MAIN_LEVEL_CONTAINER);
        this.$secondLevelContainer = this.$header.find(this.SELECTOR_MOBILE_SECOND_LEVEL_CONTAINER);

        //this.$searchToggle = $(this.SELECTOR_SEARCH_TOGGLE);
        //this.$searchContainer = $(this.SELECTOR_SEARCH_CONTAINER);
        //this.$searchInput = $(this.SELECTOR_SEARCH_INPUT);

        this.$navButton.on('click', (e) => this.onNavButtonClick(e));

        //this.$searchToggle.on('click', (e) => this.onSearchToggle(e));
        //this.$searchInput.on('blur', (e) => this.onSearchBlur(e));
        //this.$searchInput.on('focus', (e) => this.onSearchFocus(e));

        //this.$searchToggle.on('mousedown', (e) => this.onMouseDown(e));
        //this.$searchToggle.on('mouseup', (e) => this.onMouseUp(e));

        $(window).on("resize", (e) => this.onWindowResize());
        $(window).on("scroll", (e) => this.onWindowScroll(e));
        this.lastScrollPosition = $(window).scrollTop();
        l('Header init');

        this.$header.find(this.SELECTOR_MOBILE_SECOND_LEVEL_LINK).on('click', (e) => this.onSecondLevelClick(e))

    }

    private onWindowScroll(e: JQuery.ScrollEvent) {

        if (this.isNavOpen) {
            return;
        }

        const newY = $(window).scrollTop();

        if (newY > this.lastScrollPosition && newY > this.SCROLL_AMOUNT_MIN) {
            this.$header.addClass(this.STATE_NAV_HIDDEN);
        } else {
            this.$header.removeClass(this.STATE_NAV_HIDDEN);
        }

        if (newY > this.SCROLL_AMOUNT_MAX) {
            if (!this.$header.hasClass(this.STATE_SCROLLED)) {
                this.$header.addClass(this.STATE_SCROLLED);
            }
        } else {
            if (this.$header.hasClass(this.STATE_SCROLLED)) {
                this.$header.removeClass(this.STATE_SCROLLED);
            }
        }

        this.lastScrollPosition = newY;
    }

    private onSecondLevelClick(e: JQuery.ClickEvent) {


        if ($(window).width() >= this.MIN_DESKTOP_NAV_WIDTH) {
            return;
        }

        const $content = $(e.target).parent();
        this.openSecondLevel($content);

        return false;
    }

    private openSecondLevel($content: JQuery) {


        this.$secondLevelContainer.empty();

        $content.clone().appendTo(this.$secondLevelContainer);
        this.$secondLevelContainer.scrollTop(0);

        this.$navWrapper.addClass(this.STATE_MOBILE_NAV_SECOND_LEVEL);
        this.isSecondLevelOpen = true;
        this.$navButton.removeClass(this.NAV_BUTTON_STYLE_HAMBURGER);
        this.$navButton.addClass(this.NAV_BUTTON_STYLE_ARROW);
        this.$navButton.addClass(this.NAV_BUTTON_SECOND_LEVEL_CLASS);

    }

    private closeSecondLevel() {
        this.$navWrapper.removeClass(this.STATE_MOBILE_NAV_SECOND_LEVEL);
        this.$navButton.addClass(this.NAV_BUTTON_STYLE_HAMBURGER);
        this.$navButton.removeClass(this.NAV_BUTTON_STYLE_ARROW);
        this.$navButton.removeClass(this.NAV_BUTTON_SECOND_LEVEL_CLASS);
        this.isSecondLevelOpen = false;
    }

    private onNavButtonClick(e: JQuery.ClickEvent) {

        if (this.isSecondLevelOpen) {
            this.closeSecondLevel();
            return false;
        }

        if (this.isNavOpen) {
            this.closeNav();
        } else {
            this.openNav();
        }

        return false;
    }

    private closeNav() {
        this.isNavOpen = false;
        this.$navButton.removeClass(this.NAV_BUTTON_ACTIVE_CLASS);

        this.$navButton.attr('aria-pressed', this.STATE_ARIA_NAV_CLOSED);
        this.closeSecondLevel();
        $('body').removeClass(this.NAV_OPEN_BODY_CLASS);
        this.$backgroundElements.each((index, elem) => this.enableOriginalTabindex(elem));
        this.enableOriginalTabindex($('body .skip-to-content')[0]);
        this.enableOriginalTabindex($('.header .header__homelink')[0]);
        $('.header__navigationItemLink').each((index, elem) => this.enableOriginalTabindex(elem));
    }

    private openNav() {
        this.isNavOpen = true;
        this.$navButton.addClass(this.NAV_BUTTON_ACTIVE_CLASS);

        this.$backgroundElements = $('body > main, body > footer').find('a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]')
            .not('[tabindex=-1], [disabled], :hidden');

        this.$backgroundElements.each((index, elem) => this.disableFocusTemporarily(elem));
        this.disableFocusTemporarily($('body .skip-to-content')[0]);
        this.disableFocusTemporarily($('.header .header__homelink')[0]);
        $('.header__navigationItemLink').each((index, elem) => this.disableFocusTemporarily(elem));

        $('body').addClass(this.NAV_OPEN_BODY_CLASS);

        this.$navButton.attr('aria-pressed', this.STATE_ARIA_NAV_OPEN);
        this.$mainLevelContainer.scrollTop(0);

    }

    private onWindowResize() {
        if ($(window).width() >= this.MIN_DESKTOP_NAV_WIDTH && $('body').hasClass(this.NAV_OPEN_BODY_CLASS)) {
            this.closeNav();
        }
    }

    private disableFocusTemporarily(elem) {
        const $elem: JQuery = $(elem);

        const tabindex: any = $elem.attr('tabindex');

        // For some browsers, `attr` is undefined; for others, `attr` is false. Check for both.
        if (typeof tabindex !== typeof undefined && (tabindex !== false)) {
            $elem.data('original-tabindex', tabindex);
            //l('original tabindex stored');
        } else {
            $elem.data('original-tabindex', false);
            //l('elem has no tabindex');
        }

        $elem.attr('tabindex', '-1');
    }

    private enableOriginalTabindex(elem) {
        const $elem: JQuery = $(elem);

        const originalTabindex = $elem.data('original-tabindex');

        if (originalTabindex !== false) {
            $elem.attr('tabindex', originalTabindex);
            //l('original tabindex returned');
        } else {
            $elem.removeAttr('tabindex');
            //l('tabindex removed from elem')
        }
    }

}